// ─── AutoChinBot · KN3 — SMA50/TMA50 "Tụ Tách" conversation controller ───
// Turns task3's "SMA50 ↔ TMA50 cự ly ≤ x pips" (ST50 convergence) detection
// into the interactive KN3 conversation on Telegram.
//
// Design (agreed with the user):
//   • Triggered by task3 — every detected ST50 convergence starts a KN3.
//   • The decision tree is IDENTICAL to KN2 ("TMA đã mềm mại chưa?" + the
//     shared [Vào lệnh] entry); only the init text differs:
//         [SYMBOL] SMA50 và TMA50 Tụ Tách   [Test] [Vào lệnh]
//   • IT RUNS IN THE BROWSER (same as task1–task6) — the app must be open for
//     the init to go out, consistent with the rest of the pipeline.
//   • No "nhắc lại" schedule for KN3 (the case has no repeat branch).

import telegramBot from '@/lib/telegram-bot-client';
import type { AutoChinTaskEvent } from '@/lib/autochin-etask-engine';

export class AutoChinKn3Controller {
  private started = false;

  // ─── Lifecycle ──────────────────────────────────────────────

  start(): void {
    this.started = true;
  }

  stop(): void {
    this.started = false;
  }

  // ─── task3 → KN3 init ───────────────────────────────────────

  /** task3 detected SMA50/TMA50 convergence → start the KN3 conversation. */
  async notifySt50(e: AutoChinTaskEvent): Promise<void> {
    if (!this.started) return;
    try {
      await telegramBot.sendKn3({
        symbol: e.symbolName,
        symbol_id: e.symbolId,
        gap_pips: e.st50Pips ?? null,
      });
    } catch {
      /* best-effort — the next convergence will try again */
    }
  }
}